import "./FileAttachments.scss";
import { Fragment, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { bulkUploadService } from "../../services/emissionService";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  EMISSION_ATTACHMENTS_TYPE,
  EMISSION_DATA_STATUS_TYPE,
} from "../../constants/enums";
import { useSelector } from "react-redux";
import { checkPermissions } from "../../helper";
const FileAttachmentsDetails = (props: any) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const imageSrc: string = "assets/images/doc.png";
  const getPreviewImage = (image: string) => {
    return image?.includes(".jpg") ||
      image?.includes(".jpeg") ||
      image?.includes(".png") ||
      image?.includes(".avif") ||
      image?.includes(".webp")
      ? image
      : imageSrc;
  };
  const {
    formData,
    setFormData,
    sourceAttachmentData,
    setSourceAttachmentData,
    emissionLogAttachmentData,
    fromEmissionDetail,
    emissionAttachmentData,
    setEmissionAttachmentData,
    setEmissionLogAttachmentData,
    fromEmissionDetailLog,
    emissionStatus,
    externalVerifier,
    hideAttachmentsHeader,
  } = props;
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [noOfImagesUpload, setNoOfImagesUpload] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [scrollAmount, setScrollAmount] = useState(0);
  const [totalScrollWidth, setTotalScrollWidth] = useState(0);
  const handleChange = (event: any) => {
    if (event.target.files?.length) {
      const tempformData = new FormData();
      tempformData.append("file", event.target.files[0]);
      bulkUploadService(tempformData).then((res: any) => {
        setIsFileUploaded(true);
        let resultData = {} as any;
        resultData.originalName = res.data.key;
        resultData.fileName = res.data.key;
        resultData.filePath = res.data.Location;
        // from parent emisison details view
        if (emissionAttachmentData?.attachments) {
          setEmissionAttachmentData({
            ...emissionAttachmentData,
            attachments: [...emissionAttachmentData.attachments, resultData],
          });
          setNoOfImagesUpload(emissionAttachmentData?.attachments?.length + 1);
        }
        //from child emission details view
        else if (emissionLogAttachmentData?.attachments) {
          setEmissionLogAttachmentData({
            ...emissionLogAttachmentData,
            attachments: [...emissionLogAttachmentData.attachments, resultData],
          });
          setNoOfImagesUpload(
            emissionLogAttachmentData?.attachments?.length + 1
          );
        } else if (sourceAttachmentData && Object.keys(sourceAttachmentData)) {
          setNoOfImagesUpload(sourceAttachmentData?.attachments.length + 1);
          setSourceAttachmentData({
            ...sourceAttachmentData,
            attachments: [...sourceAttachmentData.attachments, resultData],
          });
        } else {
          setFormData({
            ...formData,
            attachments: [...formData.attachments, resultData],
          });
          setNoOfImagesUpload(formData?.attachments?.length + 1);
        }
        handleContainerWidthChange();
      });
    }
  };
  const getName = (file: any) => {
    const extensionOfFile =
      "." +
      file.originalName.split(".")[file.originalName.split(".").length - 1];
    const originalFileName = file.originalName?.split("/")[1];
    const requiredName = originalFileName
      .split("-")
      .slice(1, originalFileName.split("-").length)
      .join("-");
    const ans =
      requiredName?.length > 18
        ? requiredName.slice(0, 8) + "....." + extensionOfFile
        : requiredName;
    return ans;
  };
  const handleClick = () => {
    setIsFileUploaded(false);
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const handleDrop = (event: any) => {
    event.preventDefault();
    event.target.files = event.dataTransfer.files;
    handleChange(event);
  };
  const slider = useRef<HTMLDivElement | null>(null);
  let container = slider.current;

  const handleDeleteAttachments = (
    eachData: any,
    type: any,
    dataIndex?: any
  ) => {
    switch (type) {
      case EMISSION_ATTACHMENTS_TYPE.FORM_DATA:
        {
          const filteredData = formData.attachments.filter(
            (each: any, index: any) => index !== eachData
          );
          setNoOfImagesUpload(filteredData?.length);
          setFormData({
            ...formData,
            attachments: [...filteredData],
          });
        }
        break;
      case EMISSION_ATTACHMENTS_TYPE.SOURCE_DATA:
        {
          const filteredData = sourceAttachmentData.attachments.filter(
            (each: any, index: any) => index !== eachData
          );
          setNoOfImagesUpload(filteredData?.length);
          setSourceAttachmentData({
            ...sourceAttachmentData,
            attachments: [...filteredData],
          });
        }
        break;
      case EMISSION_ATTACHMENTS_TYPE.EMISSION_DATA:
        {
          const filteredData = emissionAttachmentData.attachments.filter(
            (each: any, ind: any) => ind !== dataIndex
          );
          setNoOfImagesUpload(filteredData?.length);
          setEmissionAttachmentData({
            ...emissionAttachmentData,
            attachments: [...filteredData],
          });
        }
        break;
      case EMISSION_ATTACHMENTS_TYPE.EMISSION_LOG_DATA:
        {
          const filteredData = emissionLogAttachmentData?.attachments.filter(
            (each: any, ind: any) => ind !== dataIndex
          );
          setNoOfImagesUpload(filteredData?.length);
          setEmissionLogAttachmentData({
            ...emissionLogAttachmentData,
            attachments: [...filteredData],
          });
        }
        break;

      default:
        break;
    }
    handleContainerWidthChange("del");
  };
  const handleScroll = () => {
    if (container) {
      const currentScrollAmount = container.scrollLeft;
      setScrollAmount(currentScrollAmount);
    }
  };
  const handleContainerWidthChange = (type?: any) => {
    let currentAvailableImages =
      noOfImagesUpload + (type && type === "del" ? -1 : +1);
    if (container)
      if (fromEmissionDetail) {
        setTotalScrollWidth(
          emissionAttachmentData * 120 + emissionAttachmentData * 12
        );
      }
    setTotalScrollWidth(
      currentAvailableImages * 120 + currentAvailableImages * 12
    );
  };
  useEffect(() => {
    container = slider.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      handleContainerWidthChange();
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [container]);
  const handleNext = (type: any) => {
    if (container) {
      const scrollIncrement = window.innerWidth * 0.9;
      if (type === "next") {
        container.scrollLeft += scrollIncrement;
      } else {
        container.scrollLeft -= scrollIncrement;
      }
    }
  };

  const isNextButtonVisible = slider.current
    ? scrollAmount + slider.current.clientWidth < totalScrollWidth
    : false;

  const isPrevButtonVisible = scrollAmount > 0;
  //hh
  return (
    <Fragment>
      {!hideAttachmentsHeader ? (
        <div className="pw-attchments-upload">
          <div className="text-neutral-600 text-sm">Attachments</div>
        </div>
      ) : (
        ""
      )}
      {externalVerifier === true ||
      ((emissionStatus === EMISSION_DATA_STATUS_TYPE.APPROVED
        ? checkPermissions(["UPDATE_APPROVED_EMISSIONS"], permissions)
        : checkPermissions(["UPDATE_EMISSIONS"], permissions)) &&
        emissionStatus !== EMISSION_DATA_STATUS_TYPE.REJECTED) ? (
        <Fragment>
          {
            <div
              className={`pw-dragfile-attachments flex flex-col items-center  bg-white min-h-50v ${
                fromEmissionDetail && "pw-display-none"
              } `}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <div className="flex flex-row col-gap-35 items-center">
                <div className="flex gap-x-5 whitespace-nowrap">
                  <FileUploadIcon />
                  <div className="text-neutral-500">
                    Drag and drop your file here
                  </div>
                </div>

                <div className="flex flex-row gap-4 w-full">
                  <div className="text-sm text-neutral-500">OR</div>
                </div>
                <div className="pw-e2e-bulkimportoption">
                  <input
                    type="file"
                    hidden
                    multiple
                    ref={inputRef}
                    onChange={handleChange}
                  />
                  <Button
                    className="pw-upload-button"
                    variant="outlined"
                    onClick={handleClick}
                  >
                    <FileUploadIcon />
                    Upload
                  </Button>
                </div>
              </div>
              <div className="flex flex-col gap-1 items-center text-center text-sm text-neutral-500">
                <p>
                  Supported Format : MS Office files, PDF, JPG , PNG Max File
                  size 2MB.
                </p>
              </div>
            </div>
          }
        </Fragment>
      ) : (
        ""
      )}
      <div style={{ overflowY: "auto", width: "100%" }} ref={slider}>
        <div className="flex mt-2 relative  gap-x-3 pw-bg-neutral-100 py-3 main-files-container">
          {formData?.attachments?.map((each: any, index: any) => {
            return (
              <div className="pw-attachments-each-image flex flex-col">
                <div className="pw-attachments-images">
                  <img src={getPreviewImage(each.filePath)} alt="" />
                  <div className={`pw-download-icon-div`}>
                    <Link to={each.filePath}>
                      <img src="assets/icons/download.svg" />
                    </Link>
                  </div>
                </div>
                <div className="pw-attachments-files-name">
                  <Link to={each.filePath}>
                    {" "}
                    <div>{getName(each)}</div>
                  </Link>
                </div>
                <div
                  onClick={() => handleDeleteAttachments(index, "formData")}
                  className={`pw-delete-icon-div ${
                    fromEmissionDetail && "pw-display-none"
                  } `}
                >
                  <img
                    src="assets/icons/trash-can.svg"
                    className="pw-color-red"
                  />
                </div>
                <div
                  className={`pw-download-icon-div ${
                    fromEmissionDetail && "pw-display-none"
                  } `}
                >
                  <Link to={each.filePath}>
                    <img src="assets/icons/download.svg" />
                  </Link>
                </div>
              </div>
            );
          })}
          {sourceAttachmentData?.attachments.map((each: any, index: any) => {
            return (
              <div className="pw-attachments-each-image flex flex-col">
                <div className="pw-attachments-images">
                  <img src={getPreviewImage(each.filePath)} alt="" />
                  <div className={`pw-download-icon-div`}>
                    <Link to={each.filePath}>
                      <img src="assets/icons/download.svg" />
                    </Link>
                  </div>
                </div>
                <div className="pw-attachments-files-name">
                  <Link to={each.filePath}>
                    {" "}
                    <div>{getName(each)}</div>
                  </Link>
                </div>
                {(emissionStatus === EMISSION_DATA_STATUS_TYPE.APPROVED
                  ? checkPermissions(["UPDATE_APPROVED_EMISSIONS"], permissions)
                  : checkPermissions(["UPDATE_EMISSIONS"], permissions)) &&
                emissionStatus !== EMISSION_DATA_STATUS_TYPE.REJECTED ? (
                  <div
                    onClick={() => handleDeleteAttachments(index, "sourceData")}
                    className={`pw-delete-icon-div ${
                      fromEmissionDetail && "pw-display-none"
                    } `}
                  >
                    <img
                      src="assets/icons/trash-can.svg"
                      className="pw-color-red"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
          {emissionAttachmentData?.attachments?.length > 0 &&
            emissionAttachmentData?.attachments?.map(
              (each: any, index: any) => {
                return (
                  <div className="pw-attachments-each-image flex flex-col">
                    <div className="pw-attachments-images">
                      <img src={getPreviewImage(each.filePath)} alt="" />
                      <div className={`pw-download-icon-div`}>
                        <Link to={each.filePath}>
                          <img src="assets/icons/download.svg" />
                        </Link>
                      </div>
                    </div>
                    <div className="pw-attachments-files-name">
                      <Link to={each.filePath}>
                        {" "}
                        <div>{getName(each)}</div>
                      </Link>
                    </div>
                    {(emissionStatus === EMISSION_DATA_STATUS_TYPE.APPROVED
                      ? checkPermissions(
                          ["UPDATE_APPROVED_EMISSIONS"],
                          permissions
                        )
                      : checkPermissions(["UPDATE_EMISSIONS"], permissions)) &&
                    emissionStatus !== EMISSION_DATA_STATUS_TYPE.REJECTED ? (
                      <div
                        onClick={() =>
                          handleDeleteAttachments(each, "emissionData", index)
                        }
                        className={`pw-delete-icon-div ${
                          fromEmissionDetail && "pw-display-none"
                        } `}
                      >
                        <img
                          src="assets/icons/trash-can.svg"
                          className="pw-color-red"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              }
            )}
          {emissionLogAttachmentData?.attachments?.length > 0 &&
            emissionLogAttachmentData?.attachments.map(
              (each: any, index: any) => {
                return (
                  <div className="pw-attachments-each-image flex flex-col">
                    <div className="pw-attachments-images">
                      <img src={getPreviewImage(each.filePath)} alt="" />
                      <div className={`pw-download-icon-div`}>
                        <Link to={each.filePath}>
                          <img src="assets/icons/download.svg" />
                        </Link>
                      </div>
                    </div>
                    <div className="pw-attachments-files-name">
                      <Link to={each.filePath}>
                        {" "}
                        <div>{getName(each)}</div>
                      </Link>
                    </div>
                    {(emissionStatus === EMISSION_DATA_STATUS_TYPE.APPROVED
                      ? checkPermissions(
                          ["UPDATE_APPROVED_EMISSIONS"],
                          permissions
                        )
                      : checkPermissions(["UPDATE_EMISSIONS"], permissions)) &&
                    emissionStatus !== EMISSION_DATA_STATUS_TYPE.REJECTED ? (
                      <div
                        onClick={() =>
                          handleDeleteAttachments(
                            each,
                            "emissionLogData",
                            index
                          )
                        }
                        className={`pw-delete-icon-div ${
                          fromEmissionDetail && "pw-display-none"
                        } `}
                      >
                        <img
                          src="assets/icons/trash-can.svg"
                          className="pw-color-red"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              }
            )}
          <Fragment>
            {isNextButtonVisible && (
              <div
                onClick={() => handleNext("next")}
                className="pw-next-btn flex justify-end pr-10"
              >
                <ArrowForwardIcon />
              </div>
            )}
            {isPrevButtonVisible && (
              <div
                onClick={() => handleNext("prev")}
                className="pw-next-btn pw-btn-back flex justify-start pl-10"
              >
                <ArrowBackIcon />
              </div>
            )}
          </Fragment>
        </div>
      </div>
    </Fragment>
  );
};
export default FileAttachmentsDetails;
